module.exports = __webpack_public_path__ + "icon_dove_almacen.png";